// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/inflight-icing-types.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/inflight-icing-types/inflight-icing-types.js';

mount([g0]);
